import React from "react";
import { Link } from "react-router-dom";

const TncFooter = () => {
  return (
    <div className="bg-gray-900 text-white w-full py-6 mb-4">
      <div className="max-w-6xl mx-auto text-center">
        <h3 className="text-lg font-semibold text-gray-300 uppercase tracking-wide">
          Policies & Support
        </h3>
        <div className="flex justify-center flex-wrap gap-6 mt-3">
          <Link to="/terms-and-conditions" className="text-blue-400 hover:text-blue-300 transition">
            📜 Terms & Conditions
          </Link>
          <Link to="/privacy-policy" className="text-blue-400 hover:text-blue-300 transition">
            🔒 Privacy Policy
          </Link>
          <Link to="/shipping-policy" className="text-blue-400 hover:text-blue-300 transition">
            🚚 Shipping Policy
          </Link>
          <Link to="/refund-policy" className="text-blue-400 hover:text-blue-300 transition">
            💰 Refund Policy
          </Link>
          <Link to="/ContactPage" className="text-blue-400 hover:text-blue-300 transition">
            📞 Contact Support
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TncFooter;
